/**
 * Created by web7 on 18/04/2019.
 */

import EventEmitter from  'events';

export default class Expedicar extends EventEmitter {
    constructor() {
        super();
        this.expedicarTimer = null;
    }

    /**
     *
     * @param arrivalAddress
     * @param arrivalZipCode
     * @param arrivalCity
     * @param arrivalCountry
     * @param businessUnitCodeDeparture
     * @returns {Promise<unknown>}
     */
    static deliverySimulation(arrivalAddress, arrivalZipCode, arrivalCity, arrivalCountry, businessUnitCodeDeparture)
    {
        return new Promise((resolve, rejec) => {
            let params = new URLSearchParams();

            params.append(`arrivalAddress`, arrivalAddress);
            params.append(`arrivalZipCode`, arrivalZipCode);
            params.append(`arrivalCity`, arrivalCity);
            params.append(`arrivalCountry`, arrivalCountry);
            params.append(`businessUnitCodeDeparture`, businessUnitCodeDeparture);

            const url = `${window.location.protocol}//${window.location.host}/expedicar/getSimulationJourneyPricing?${params.toString()}`;
            fetch(url).then(response => {
                response.json().then(json => {
                    resolve(json);
                }).catch(error => rejec(error));
            }).catch(error => rejec(error));
        });
    }

    onExpedicarChange(suffix) {
        const elementExpedicarLoading = $(`#expedicarLoading${suffix}`);
        const elementPriceJourney = $(`#priceJourney${suffix}`);
        const elementMsgExpedicarLoading = $(`#msgExpedicarLoading${suffix}`);
        const elementErrorExpedicar = $(`#errorExpedicar${suffix}`);

        elementExpedicarLoading.removeClass('hide');
        elementPriceJourney.addClass('hide');
        elementMsgExpedicarLoading.removeClass('hide');
        elementErrorExpedicar.addClass('hide');

        $('#deliveryAddressExpedicarQuotation').data('price', null);

        if (this.expedicarTimer !== null) {
            clearTimeout(this.expedicarTimer);
        }

        this.expedicarTimer = setTimeout(() => {
            const elementAddress = $(`#deliveryAddressExpedicar${suffix}`);
            const vehicleIdParam = elementAddress.data('value');
            const address = elementAddress.val();
            const zipCode = $(`#deliveryZipCodeExpedicar${suffix}`).val();
            const city = $(`#deliveryCityExpedicar${suffix}`).val();
            const country = $(`#deliveryCountryExpedicar${suffix}`).val();

            if (address.length > 0 && zipCode.length > 0 && city.length > 0 && country.length > 0) {
                const params = new URLSearchParams();

                params.append(`arrivalAddress`, address);
                params.append(`arrivalZipCode`, zipCode);
                params.append(`arrivalCity`, city);
                params.append(`arrivalCountry`, country);

                if($(`#expedicarWithHandoverService${suffix}`).is(':checked'))
                {
                    params.append(`additionalServices[]`, $(`#expedicarWithHandoverService${suffix}`).val());
                }

                if($(`#expedicarWithExteriorWashing${suffix}`).is(':checked'))
                {
                    params.append(`additionalServices[]`, $(`#expedicarWithExteriorWashing${suffix}`).val());
                }

                const url = `${window.location.protocol}//${window.location.host}/expedicar/getJourneyPricing/${vehicleIdParam}?${params.toString()}`;

                $.getJSON(url).done(response => {

                    const price = response.price;

                    this.emit('success', price);
                    $('#deliveryAddressExpedicarQuotation').data('price', price);

                    elementExpedicarLoading.addClass('hide');
                    elementPriceJourney.text(price + '€.');
                    elementPriceJourney.removeClass('hide');
                    elementMsgExpedicarLoading.addClass('hide');

                    this.emit('finish');

                }).fail(() => {
                    elementExpedicarLoading.addClass('hide');
                    elementMsgExpedicarLoading.addClass('hide');
                    elementErrorExpedicar.removeClass('hide');

                    this.emit('finish');
                });
            } else {
                elementExpedicarLoading.addClass('hide');
                elementPriceJourney.text('0 €.');
                elementPriceJourney.removeClass('hide');
                elementMsgExpedicarLoading.addClass('hide');
            }
        }, 1000);

        return this.expedicarTimer;
    }
}
